import { Component, ViewChild } from '@angular/core';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { CommonService } from '../../../Model/Common/common.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import moment from 'moment';

@Component({
  selector: 'app-registration-approval',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbDatepickerModule, DataTablesModule, RouterModule, LoaderComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './registration-approval.component.html',
  styleUrl: './registration-approval.component.scss'
})
export class RegistrationApprovalComponent {
  isDisabled: boolean = false;
  user = [] as any;
  RestData: any[] = []
  Filter = {
    ModuleMasterId: 1,
    FromDate: '' as any,
    ToDate: '' as any,
    FromDateObj: null as any,
    ToDateObj: null as any,
    EmpMasterId: 0,
    SelectType1: 'D',
    SelectType: 'Pending',
    TransactionId: 0,
    //EmpType: 'front',
    Remark: null
  }
  Counts = {
    ApprovedCount: 0,
    PendingCount: 0,
    PendingWithSeniorCount: 0,
    RejectedCount: 0,
    ReinitiatedCount: 0,
    TransactionId: 0
  }
  TotalCount: number = 0;
  MainDatas = [];
  TableDatas = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private utility: UtilityService,
    private toast: ToastService,
    private approvalMatrix: ApprovalMatrixService,
    private dateFormat: CustomDateParserFormatter,
    protected common: CommonService,
    private modalService: NgbModal,
    private tooltip: TooltipService,
    private session: SessionService,
  ) {
    this.user = this.session.GetUserDetails();
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.SelectDate('RegistrationDate', null, null);
    this.common.CheckExpiry();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Filter.FromDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.FromDateObj.day = 1;
          this.Filter.ToDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.ToDateObj.day = new Date(this.Filter.ToDateObj.year, this.Filter.ToDateObj.month, 0).getDate();
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.ApprovalMatrixRequest(this.Filter.ModuleMasterId);
      },
      error: (error) => {
        this.isDisabled = false;
        this.toast.show({ message: error, type: toastTypeEnum.danger });
        return false;
      },
    });
  }

  FilterValidate(form: any) {
    if (form.valid) {
      this.ApprovalMatrixRequest(this.Filter.ModuleMasterId);
    }
    else {
      form.submitted = true;
    }
  }

  ApprovalMatrixRequest(id: number) {
    if (this.common.ToLowerCase(this.Filter.SelectType) == 'pending' || (this.common.ToLowerCase(this.Filter.SelectType) != 'pending' && (moment(this.dateFormat.format(this.Filter.ToDateObj), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormat.format(this.Filter.FromDateObj), 'DD MMM YYYY'))))) {
      this.Filter.ModuleMasterId = id;
      this.MainDatas = [];
      this.TableDatas = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
      this.ApprovalMatrixRequestGet();
      this.ApprovalMatrixRequestGetCount();
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
  }

  ApprovalMatrixRequestGet() {
    this.isDisabled = true;
    if (this.Filter.SelectType == 'Pending') {
      this.Filter.FromDate = null;
      this.Filter.ToDate = null;
    } else {
      this.Filter.FromDate = this.Filter.FromDateObj.year + '-' + this.Filter.FromDateObj.month + '-' + this.Filter.FromDateObj.day;
      this.Filter.ToDate = this.Filter.ToDateObj.year + '-' + this.Filter.ToDateObj.month + '-' + this.Filter.ToDateObj.day;
    }
    this.approvalMatrix.ApprovalMatrixRequestGet(this.Filter).subscribe({
      next: (response) => {
        if (this.Filter.ModuleMasterId == 1 || this.Filter.ModuleMasterId == 2) {
          this.MainDatas = response.Table;
          this.TableDatas = Object.values(this.MainDatas);
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
          this.TotalCount = this.TableDatas.length;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestGetCount() {
    this.isDisabled = true;
    this.Filter.FromDate = this.Filter.FromDateObj.year + '-' + this.Filter.FromDateObj.month + '-' + this.Filter.FromDateObj.day;
    this.Filter.ToDate = this.Filter.ToDateObj.year + '-' + this.Filter.ToDateObj.month + '-' + this.Filter.ToDateObj.day;
    this.approvalMatrix.ApprovalMatrixRequestGet({ ModuleMasterId: this.Filter.ModuleMasterId, FromDate: this.Filter.FromDate, ToDate: this.Filter.ToDate, EmpMasterId: this.Filter.EmpMasterId, SelectType1: 'S', SelectType: '' }).subscribe({
      next: (response) => {
        this.Counts = response.Table[0];
        if (this.Filter.ModuleMasterId == 1) {
          this.common.MenuCounts.Approval.Registration.MenualOnBoard = response.Table[0].PendingCount;
        } else if (this.Filter.ModuleMasterId == 2) {
          this.common.MenuCounts.Approval.Registration.PreOnBoard = response.Table[0].PendingCount;
        }
        // this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ARCheck(event: any, i: number, IsAll = false, IsAll2 = false) {
    if (IsAll) {
      const ischeck = (event.target as HTMLInputElement).checked;

      const checkboxes = document.getElementsByName('IsCheckAll') as NodeListOf<HTMLInputElement>;
      checkboxes.forEach(checkbox => {
        checkbox.checked = false;
      });
      (event.target as HTMLInputElement).checked = ischeck;

      try {
        const dt = await this.dtElement.dtInstance;
        const pageInfo = dt.page.info();
        const currentPage = pageInfo.page;
        const start = pageInfo.start;
        const end = pageInfo.end - 1;

        const updatedData = [...this.TableDatas];

        if (IsAll2) {
          updatedData.forEach(e => e.IsARCheck = ischeck);
        } else {
          updatedData.forEach(e => e.IsARCheck = false);
          for (let i = start; i <= end; i++) {
            if (updatedData[i]) {  // Safety check
              updatedData[i].IsARCheck = ischeck;
            }
          }
        }

        this.TableDatas = updatedData;

        setTimeout(() => {
          if (this.dtElement?.dtInstance) {
            this.dtElement.dtInstance.then((dtInstance: any) => {
              dtInstance.page(currentPage).draw('page');
            });
          }
        }, 50);
      } catch (e) {
        console.error('Error in ARCheck:', e);
      }
    } else {
      this.TableDatas[i].IsARCheck = event.target.checked;
    }
  }

  ApprovalMatrixRequestProcess(SelectType: string) {
    if (this.TableDatas.filter((e: any) => e.IsARCheck).length > 0) {
      if ((SelectType == 'Reject' && this.Filter.Remark != '' && this.Filter.Remark != null) || SelectType == 'Approve') {
        const modalRef = this.modalService.open(ConfirmationComponent, {
          size: 'md',
          backdrop: 'static',
          centered: true,
          windowClass: 'confirmation-modal'
        });
        modalRef.componentInstance.Message = 'Do you want to ' + SelectType + '?';
        modalRef.result.then(async (result: any) => {
          if (result) {
            this.isDisabled = true;
            const length = this.TableDatas.filter((e: any) => e.IsARCheck).length;
            let index = 0;
            await this.TableDatas.filter((e: any) => e.IsARCheck).forEach(async (element: any) => {
              await this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: element.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, approvedid: element.EmpMasterId }).subscribe({
                next: async (response) => {
                  index += 1;
                  if (response.Error_Code == '49' || response.Error_Code == '50' || response.Error_Code == '51') {
                    //this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                  }
                  // else if (response.Error_Code == '49') {
                  //   if (this.user.CompanyCode === 'MSF' || this.user.CompanyCode === 'MFM') {
                  //     if (!this.common.CompanyParameterValue.DefaultAPIIntegration && !this.common.CompanyParameterValue.ZingHRAPIIntegration && !this.common.CompanyParameterValue.ProptorAPIIntegration) {

                  //     }
                  //     else {
                  //       if (response.EmpCodeForFRONT !== '') {
                  //         await this.Transovative(response.EmpCodeForFRONT);
                  //       }
                  //     }
                  //   }
                  // }
                  else {
                    this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
                  }
                  if (index == length) {
                    this.isDisabled = false;
                    this.ApprovalMatrixRequest(this.Filter.ModuleMasterId);
                    //location.reload();
                    this.toast.show({ message: 'Selected entry ' + SelectType, type: toastTypeEnum.success });
                  }
                },
                complete: () => { },
                error: (error) => {
                  this.isDisabled = false;
                },
              });
            });
          }
        }).catch(() => { });
      } else {
        this.toast.show({ message: 'Please enter remark', type: toastTypeEnum.warning });
      }
    } else {
      this.toast.show({ message: 'Kindly select atleast one request', type: toastTypeEnum.warning });
    }
  }

  clear() {
    this.MainDatas = [];
    this.TableDatas = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
  // async Transovative(id: any) {
  //   const data = {
  //     SQL_TableName: 'EmpMaster',
  //     SQL_IDColumnName: 'EmpMasterId',
  //     DefaultSyncAPI: false,
  //     ZingHRSyncAPI: false,
  //     ProptorSyncAPI: false,
  //     UserId: this.user.UserId,
  //     Id: id
  //   }
  //   await this.approvalMatrix.SetSyncAPIFlagIn(data).subscribe({
  //     next: async (response) => {
  //       await this.approvalMatrix.GetMaster({ MasterName: 'Employee', MasterCode: id }).subscribe({
  //         next: async (response) => {
  //           if (response.Table.length > 0) {
  //             const employeeAdd = {
  //               username: response.Table[0].username,
  //               empid: response.Table[0].empid,
  //               Contactno: response.Table[0].Contactno,
  //               Emailid: response.Table[0].Emailid,
  //               Role: response.Table[0].Role,
  //               Branch: response.Table[0].Branch,
  //               Bh: response.Table[0].Bh,
  //               Designation: response.Table[0].Designation,
  //               Siteowneruserid: response.Table[0].Siteowneruserid,
  //               Fathersname: response.Table[0].Fathersname,
  //               Doj: response.Table[0].Doj,
  //               Dob: response.Table[0].Dob,
  //               Nativeplace: response.Table[0].Nativeplace,
  //               State: response.Table[0].State,
  //               Siteid: response.Table[0].Siteid,
  //               Location: response.Table[0].Location,
  //               Dutyhrs: response.Table[0].Dutyhrs,
  //               Bankname: response.Table[0].Bankname,
  //               Aadharno: response.Table[0].Aadharno,
  //               Age: response.Table[0].Age,
  //               Address: response.Table[0].Address,
  //               companycode: response.Table[0].CompanyCode,
  //               OperationType: 'Employee',
  //               Action: 'add'
  //             }
  //             await this.approvalMatrix.SubMasterApi(employeeAdd).subscribe({
  //               next: (response) => {
  //                 this.RestData = response
  //                 alert(response.DefaultMessage);
  //               },
  //               complete: async () => {
  //                 await this.Transovative_SubMasterApi_ConsumptionLogs('Employee', id, this.RestData, response.Table[0]);
  //                 this.isDisabled = false;
  //               },
  //               error: (error: any) => {
  //                 this.isDisabled = false;
  //               },
  //             });
  //           }
  //         },
  //         complete: () => {
  //           this.isDisabled = false;
  //         },
  //         error: (error: any) => {
  //           this.isDisabled = false;
  //         },
  //       });
  //     },
  //     complete: () => {
  //       this.isDisabled = false;
  //     },
  //     error: (error: any) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }
  // Transovative_SubMasterApi_ConsumptionLogs(name: string, id: any, res: any, requestjson: any) {
  //   const employeeAdd = {
  //     username: requestjson.username,
  //     empid: requestjson.empid,
  //     Contactno: requestjson.Contactno,
  //     Emailid: requestjson.Emailid,
  //     Role: requestjson.Role,
  //     Branch: requestjson.Branch,
  //     Bh: requestjson.Bh,
  //     Designation: requestjson.Designation,
  //     Siteowneruserid: requestjson.Siteowneruserid,
  //     Fathersname: requestjson.Fathersname,
  //     Doj: requestjson.Doj,
  //     Dob: requestjson.Dob,
  //     Nativeplace: requestjson.Nativeplace,
  //     State: requestjson.State,
  //     Siteid: requestjson.Siteid,
  //     Location: requestjson.Location,
  //     Dutyhrs: requestjson.Dutyhrs,
  //     Bankname: requestjson.Bankname,
  //     Aadharno: requestjson.Aadharno,
  //     Age: requestjson.Age,
  //     Address: requestjson.Address,
  //     companycode: requestjson.CompanyCode,
  //     OperationType: 'Employee',
  //     Action: 'add'
  //   }

  //   const data = {
  //     requestJson: employeeAdd,
  //     UserId: this.user.UserId,
  //     OperationType: 'Employee',
  //     UnitCode: id,
  //     UnitDescription: name,
  //     DefaultReturnCode: res.DefaultReturnCode,
  //     DefaultMessage: res.DefaultMessage,
  //     ActionType: 'addemployeedetails',
  //   }
  //   this.approvalMatrix.Transovative_SubMasterApi_ConsumptionLogs(data).subscribe({
  //     next: (response) => {
  //     },
  //     complete: () => {
  //       this.isDisabled = false;
  //     },
  //     error: (error: any) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }
}
